import { Box, Stack } from '@mui/material'

export enum IndicatorStatus {
  Green,
  Yellow,
  Red,
}

type Props = React.PropsWithChildren & {
  status: IndicatorStatus
}

export const Indicator = (props: Props) => {
  const statusColors = new Map<IndicatorStatus, string>([
    [IndicatorStatus.Green, 'success.main'],
    [IndicatorStatus.Yellow, 'warning.main'],
    [IndicatorStatus.Red, 'error.main'],
  ])
  return (
    <Stack direction="row" spacing={1.25} alignItems="center">
      <Box
        sx={{
          width: (theme) => theme.spacing(1.25),
          height: (theme) => theme.spacing(1.25),
          borderRadius: '100%',
          flexShrink: 0,
          backgroundColor: statusColors.get(props.status) ?? '',
        }}
      />
      <Box>{props.children}</Box>
    </Stack>
  )
}
